import { z } from 'zod';

export const PaginationSchema = z.object({
   page: z.number(),
   limit: z.number(),
   total: z.number().nullable(),
});

export const ProductItemPaginationSchema = PaginationSchema.extend({
   status: z.string().optional(),
   type: z.string().optional(),
});
